import { Col, Row } from 'react-bootstrap';

import { Stack } from 'apps/dashboard/shared/scripts/components';
import { CardFragment } from 'apps/shared/scripts/graphql/fragments/CardFragment.generated';

import { CardArchive, CardPreview } from '../../components';

interface Props {
  card: CardFragment;
}

const CardArchivedContainer = ({ card }: Props) => {
  return (
    <Row>
      <Col lg={7}>
        <Stack>
          <CardArchive card={card} />
        </Stack>
      </Col>
      <Col lg={5}>
        <CardPreview
          formValues={{
            designId: card.design.id,
            headline: card.headline,
            recipientName: card.recipientName,
            senderName: card.senderName ?? '',
          }}
        />
      </Col>
    </Row>
  );
};

CardArchivedContainer.displayName = 'CardArchivedContainer';

export default CardArchivedContainer;
